import { useCallback } from 'react'
import ModalDeleteFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { RowData } from '../../../../../../../../../../baseComponents/TwinTable/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { twinFetchPostJSON } from '../../../../../../../../../../utils/globals/data'
import { getBasePath } from '../../../../../../../../../../utils/globals/link'
import { useLocation, useNavigate } from 'react-router'

interface MModalDeleteLastVersionProps extends ModalEditComponentProps { }

const ModalDeleteLastVersion: React.FC<MModalDeleteLastVersionProps> = ({ setOpened, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleOnAccept } = useModalDeleteLastVersionLogic({allRowData: allRowData || []})
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleOnAccept} translations={{
            title: t('sureDeleteThisQuoteOrderVersion', '¿Seguro que quieres eliminar esta versión del presupuesto?'),
            subtitle: t('onceDeletedNotRecover', 'Una vez eliminada no podrás recuperarla')
        }} />
    )
}

interface ModalDeleteLastVersionLogicProps {
    allRowData: RowData
}

const useModalDeleteLastVersionLogic = ({ allRowData }: ModalDeleteLastVersionLogicProps) => {
    const navigate = useNavigate()
    const location = useLocation()
    const basePath = getBasePath(location.pathname, 'single')
    const handleOnAccept = useCallback(async () => {
        const lastQuoteOrder = await twinFetchPostJSON('/api/app/order/quote/deleteLastQuoteOrderVersionDraft', { id: allRowData?.header?.id, })
        if (lastQuoteOrder) {
            navigate(basePath + '/' + lastQuoteOrder.id)
        }
    }, [allRowData, basePath, navigate])

    return { handleOnAccept }
}

export default ModalDeleteLastVersion